<div
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  #motionMenu
  [ngClass]="{
    isOpen: isOpen,
    isMobile: isMobile$ | async,
    disabled: blockOpenOnHover,
  }"
  class="main"
>
  @if (!(isMobile$ | async)) {
    <div [routerLink]="['/']" class="top">
      @if (customLogo) {
        <div class="small" [innerHTML]="customLogo"></div>
      } @else {
        <ng-template [ngTemplateOutlet]="defaultLogo"></ng-template>
      }
      <ng-template #defaultLogo>
        <div class="small">
          <svg
            id="Zalamo"
            viewBox="0 0 283.46 94.63"
            x="0px"
            xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg"
            y="0px"
          >
            <path
              d="M124.329,54.564h10.79v2.652h-14.796V55.09l10.689-12.744h-10.364v-2.653h14.346v2.128L124.329,54.564z M148.337,53.262
	l-1.678,3.955h-3.079l7.736-17.524h3.029l7.66,17.524h-3.154l-1.678-3.955H148.337z M152.743,42.847l-3.305,7.786h6.609
	L152.743,42.847z M181.631,54.539v2.678h-10.54V39.693h2.954v14.846H181.631z M194.645,53.262l-1.678,3.955h-3.08l7.736-17.524
	h3.029l7.661,17.524h-3.154l-1.678-3.955H194.645z M199.05,42.847l-3.305,7.786h6.609L199.05,42.847z M233.195,57.217l-0.024-13.093
	l-5.532,11.267h-1.929l-5.532-11.267v13.093h-2.779V39.693h3.505l5.783,11.641l5.759-11.641h3.479v17.524H233.195z M264.601,48.455
	c0,5.006-4.056,8.887-9.288,8.887s-9.289-3.881-9.289-8.887c0-5.033,4.057-8.837,9.289-8.837S264.601,43.448,264.601,48.455z
	 M249.028,48.455c0,3.48,2.878,6.232,6.309,6.232c3.43,0,6.233-2.752,6.233-6.232c0-3.48-2.804-6.184-6.233-6.184
	C251.882,42.271,249.028,44.975,249.028,48.455z"
            />
            <path
              d="M96.995,33.206c-0.024-0.227-0.161-1.392-0.447-2.08c-0.608-1.47-1.789-2.647-3.256-3.252l0.004-0.009l-12.399-4.884
	c-0.859-0.367-1.547-1.076-1.889-1.948l-1.887-4.778l-0.017-0.042c-0.931-2.25-3.105-3.704-5.541-3.704H43.728
	c-2.436,0-4.61,1.454-5.54,3.702l-1.905,4.825c-0.341,0.87-1.028,1.578-1.888,1.945l-12.398,4.884l0.003,0.009
	c-1.467,0.605-2.647,1.782-3.255,3.251c-0.287,0.69-0.424,1.855-0.447,2.082l-0.008,0.067v30.84c0,3.307,2.689,5.988,5.994,5.988
	h7.73v12.02l12.109-12.02h46.885c3.305,0,5.994-2.682,5.994-5.988V33.34L96.995,33.206z M94.51,64.113
	c0,1.932-1.571,3.502-3.502,3.502H43.102l-8.608,8.549v-8.549h-10.21c-1.931,0-3.502-1.57-3.502-3.502V33.411
	c0.051-0.426,0.164-1.087,0.266-1.332c0.368-0.891,1.096-1.598,1.998-1.938l-0.004-0.008l12.283-4.838l0.029-0.012
	c1.479-0.625,2.664-1.842,3.248-3.334l1.869-4.736l0.02-0.046c0.544-1.314,1.814-2.163,3.237-2.163h27.836
	c1.423,0,2.694,0.849,3.237,2.165l1.887,4.778c0.586,1.495,1.771,2.711,3.25,3.337l12.312,4.85l-0.003,0.008
	c0.9,0.341,1.629,1.047,1.998,1.939c0.093,0.224,0.208,0.853,0.265,1.331V64.113z M57.664,61.469L43.303,47.124
	c-1.088-1.088-1.897-2.385-2.398-3.844c-1.26-3.674-0.337-7.663,2.408-10.408c1.904-1.905,4.436-2.954,7.129-2.954
	s5.227,1.049,7.131,2.953l0.076,0.077l0.073-0.074c1.908-1.907,4.44-2.956,7.134-2.956s5.226,1.049,7.13,2.954
	c2.745,2.746,3.667,6.734,2.407,10.408c-0.501,1.459-1.311,2.756-2.409,3.854L57.664,61.469z M50.441,32.397
	c-2.03,0-3.94,0.791-5.377,2.228c-2.069,2.07-2.765,5.079-1.814,7.851c0.377,1.099,0.988,2.076,1.816,2.904l12.582,12.596
	L70.23,45.381c0.828-0.829,1.44-1.806,1.816-2.905c0.951-2.772,0.256-5.781-1.814-7.851c-1.437-1.437-3.346-2.228-5.377-2.228
	s-3.941,0.791-5.378,2.228l-1.823,1.835l-1.835-1.835C54.383,33.188,52.473,32.397,50.441,32.397z"
            />
          </svg>
        </div>
      </ng-template>
    </div>
  }
  <div #links [ngClass]="{ notLoaded: menuConfigNotLoaded }" class="middle">
    <mat-nav-list [class.motion-disabled]="menuConfigNotLoaded">
      @if (isMobile$ | async) {
        <a
          animate.enter="pop-enter" animate.leave="pop-leave"
          [routerLink]="['/']"
          id="ZalamoMainMenuHomeButton"
          mat-list-item
          class="navigation-item"
        >
          <mat-icon matListItemIcon class="navigation-icon">home</mat-icon>
          @if (isOpen || isMobileOpen || isHorizontal) {
            <span matListItemTitle class="navigation-title">
              Strona głowna
            </span>
          }
        </a>
      }
      @if (hasAdd) {
        <a
          (click)="openAdd()"
          animate.enter="pop-enter" animate.leave="pop-leave"
          id="ZalamoMainMenuAddButton"
          mat-list-item
          class="navigation-item"
        >
          <mat-icon matListItemIcon class="navigation-icon"
            >add_circle</mat-icon
          >
          @if (isOpen || isMobileOpen || isHorizontal) {
            <span matListItemTitle class="navigation-title">Dodaj</span>
          }
        </a>
      }
      @if (hasZalamoPrint) {
        <a
          animate.enter="pop-enter" animate.leave="pop-leave"
          id="ZalamoMainMenuZalamoPrint"
          mat-list-item
          class="navigation-item"
          routerLink="/zalamo-print"
          routerLinkActive="active-link"
        >
          <mat-icon
            matListItemIcon
            class="navigation-icon"
            svgIcon="zalamoPrintLogo"
          ></mat-icon>
          @if (isOpen || isMobileOpen || isHorizontal) {
            <span matListItemTitle class="navigation-title">Zalamo Print</span>
          }
        </a>
      }
      @if (hasZalamoPrint) {
        <a
          animate.enter="pop-enter" animate.leave="pop-leave"
          id="ZalamoMainMenuSignupCampaign"
          mat-list-item
          class="navigation-item"
          routerLink="/public-sessions/signups"
          routerLinkActive="active-link"
        >
          <mat-icon
            matListItemIcon
            class="navigation-icon"
            svgIcon="marketing"
          ></mat-icon>
          @if (isOpen || isMobileOpen || isHorizontal) {
            <span matListItemTitle class="navigation-title"
              >Zapisy grupowe</span
            >
          }
        </a>
      }
      @for (link of sortedMenu$ | async; track trackMenuItem($index, link)) {
        <a
          (click)="navClicked()"
          (smartPreviewOpen)="isPreviewOpen = $event"
          (smartPreviewVisited)="previewEntered = $event"
          animate.enter="pop-enter" animate.leave="pop-leave"
          [attr.data-vg]="'VisualGuideMainNavLink' + link.id"
          [libSmartPreview]="link.id"
          [position]="isHorizontal ? 'below' : 'right'"
          [routerLink]="link.path"
          id="ZalamoMainMenu{{ link.id }}"
          mat-list-item
          class="navigation-item"
          routerLinkActive="active-link"
        >
          @if (!link.isMatIcon) {
            <mat-icon
              [matBadge]="link.badge"
              [svgIcon]="link.icon"
              matListItemIcon
              class="navigation-icon"
              matBadgeSize="small"
            ></mat-icon>
          } @else {
            <ng-template [ngTemplateOutlet]="matIcon"></ng-template>
          }
          <ng-template #matIcon>
            <mat-icon
              [matBadge]="link.badge"
              matListItemIcon
              class="navigation-icon"
              matBadgeSize="small"
              >{{ link.icon }}</mat-icon
            >
          </ng-template>
          @if (isOpen || isMobileOpen || isHorizontal) {
            <span matListItemTitle class="navigation-title">{{
              link.label
            }}</span>
          }
        </a>
      }
      @if (!disableAllAps) {
        <mat-list-item (click)="openAll()" class="navigation-item others">
          <mat-icon matListItemIcon class="navigation-icon">apps</mat-icon>
          <span matListItemTitle class="navigation-title"
            >Wszystkie</span
          ></mat-list-item
        >
      }
    </mat-nav-list>
  </div>
  <div class="footer">
    @if (showCommentsIcon) {
      <lib-unseen-comments-icon
        (smartPreviewOpen)="isPreviewOpen = $event"
        (smartPreviewVisited)="previewEntered = $event"
      ></lib-unseen-comments-icon>
    }
    @if (hasApp) {
      <div
        class="appTasks"
        animate.enter="pop-enter" animate.leave="pop-leave"
        [ngClass]="{ hasTasks: appTasksInProgress }"
        (click)="showAppTasks.emit()"
      >
        <div>
          <span>
            <div class="svg">
              <svg viewBox="0 0 150 150">
                <circle
                  cx="50%"
                  cy="50%"
                  r="75"
                  class="svg-circle"
                  fill="none"
                ></circle>
                <circle
                  cx="50%"
                  cy="50%"
                  r="75"
                  class="svg-circle animated"
                ></circle>
                <circle
                  cx="50%"
                  cy="50%"
                  r="65"
                  class="svg-circle animated"
                ></circle>
              </svg>
            </div>
            {{ appTasksInProgress }}</span
          >
          Zadania aplikacji
        </div>
      </div>
    }
    @if (hasUpload && uploadInProgress > 0) {
      <div
        (click)="openUploadQueue()"
        (smartPreviewOpen)="isPreviewOpen = $event"
        (smartPreviewVisited)="previewEntered = $event"
        animate.enter="pop-enter" animate.leave="pop-leave"
        class="upload"
        libSmartPreview="upload"
      >
        <div class="ctn">
          <mat-icon>cloud_upload</mat-icon>
          <lib-progress-spinner
            [value]="(100 * uploadDone) / uploadInProgress"
            diameter="45"
            mode="determinate"
          ></lib-progress-spinner>
          <span>{{ uploadDone }} / {{ uploadInProgress }}</span>
        </div>
      </div>
    }

    <mat-nav-list>
      @if ((organizationsInPlay$ | async)?.length > 1) {
        <mat-list-item
          class="navigation-item"
          [matMenuTriggerFor]="mineOrganizations"
        >
          <mat-icon matListItemIcon class="navigation-icon"
            >workspaces</mat-icon
          >
          <span matListItemTitle class="navigation-title">{{
            (currentOrganization$ | async)?.name
          }}</span></mat-list-item
        >
      }
      <mat-list-item class="navigation-item" [matMenuTriggerFor]="menu">
        <mat-icon matListItemIcon class="navigation-icon"
          >account_circle</mat-icon
        >
        <span matListItemTitle class="navigation-title"
          >Moje konto</span
        ></mat-list-item
      >
    </mat-nav-list>
  </div>
</div>
<mat-menu
  #menu="matMenu"
  (pointerleave)="lockMouseOver = false"
  class="bottom-menu"
  xPosition="after"
>
  @for (item of bottomMenu; track item) {
    @if (!item.url[0].startsWith('http')) {
      <button
        (click)="navClicked()"
        (pointerleave)="lockMouseOver = false"
        [routerLink]="item.url"
        mat-menu-item
      >
        {{ item.label }}
      </button>
    }
    @if (item.url[0].startsWith('http')) {
      <a
        (pointerleave)="lockMouseOver = false"
        href="{{ item.url }}"
        target="_blank"
        mat-menu-item
      >
        {{ item.label }}
      </a>
    }
  }
  <button (click)="logout.emit()" mat-menu-item>Wyloguj</button>
</mat-menu>
<mat-menu
  #mineOrganizations="matMenu"
  (pointerleave)="lockMouseOver = false"
  class="bottom-menu"
  xPosition="after"
>
  @for (item of organizationsInPlay$ | async; track item) {
    <button
      (click)="organizationService.changeOrganization(item.organizationId)"
      (pointerleave)="lockMouseOver = false"
      mat-menu-item
      [ngClass]="{
        active:
          item.organizationId ===
          (currentOrganization$ | async)?.organizationId,
      }"
    >
      {{ item.name }}
    </button>
  }
</mat-menu>
@if (isMobile$ | async) {
  <div class="mobile-menu">
    <button
      (click)="isMobileOpen = !isMobileOpen"
      class="mobile-open"
      mat-icon-button
    >
      <mat-icon>menu</mat-icon>
    </button>
    @if (hasSubMenu$ | async) {
      <button
        (click)="showMobile.emit(true)"
        class="mobile-open"
        mat-icon-button
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    }

    <button (click)="isOpen = true" class="mobile-open" mat-icon-button>
      <mat-icon>help</mat-icon>
    </button>
  </div>
}
<ng-template #allApps let-close="close">
  <div class="allApps">
    <div
      cdkDropList
      cdkDropListOrientation="mixed"
      [cdkDropListDisabled]="sortingDisabled"
      (cdkDropListDropped)="sortMenu($event)"
      [cdkDropListData]="wholeMenu"
      class="items"
    >
      @for (link of wholeMenu; track link) {
        <div class="item" cdkDrag>
          <div class="visibility">
            <button
              (click)="
                changeVisibility.emit({
                  id: link.id,
                  visibility: !link.isVisible,
                })
              "
              mat-icon-button
            >
              @if (link.isVisible) {
                <mat-icon matTooltip="pokaź w menu głównym"
                  >visibility
                </mat-icon>
              }
              @if (!link.isVisible) {
                <mat-icon matTooltip="ukryj w menu głównym"
                  >visibility_off
                </mat-icon>
              }
            </button>
          </div>
          <div [routerLink]="link.path" class="icon">
            @if (!link.isMatIcon) {
              <mat-icon
                [matBadge]="link.badge"
                [svgIcon]="link.icon"
                matBadgePosition="before"
              ></mat-icon>
            } @else {
              <ng-template [ngTemplateOutlet]="isMatIcon"></ng-template>
            }
            <ng-template #isMatIcon>
              <mat-icon [matBadge]="link.badge" matBadgePosition="before">{{
                link.icon
              }}</mat-icon>
            </ng-template>
          </div>

          <span [routerLink]="link.path">{{ link.label }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #addPanel>
  <div class="addPanel">
    <div class="items">
      @for (link of availableForAddTopPriority; track link) {
        <div class="item-container">
          <div
            (click)="link.handler(); closeAddWindow()"
            class="item"
            [attr.data-attr]="'VirtualGuideAddPanel' + link.id"
          >
            <div class="icon">
              <mat-icon
                [matBadge]="link.badge"
                [svgIcon]="link.icon"
                matBadgePosition="before"
              ></mat-icon>
            </div>
            <span translate>AddButton{{ link.id }}</span>
          </div>
          <p></p>
        </div>
      }
    </div>
    <div class="items lowPriority">
      @for (link of availableForAddLowPriority; track link) {
        <div class="item-container">
          <div (click)="link.handler(); closeAddWindow()" class="item">
            <div class="icon">
              @if (!link.isMatIcon) {
                <mat-icon
                  [matBadge]="link.badge"
                  [svgIcon]="link.icon"
                  matBadgePosition="before"
                ></mat-icon>
              } @else {
                <ng-template [ngTemplateOutlet]="matIcon"></ng-template>
              }
              <ng-template #matIcon>
                <mat-icon [matBadge]="link.badge" matBadgePosition="before">{{
                  link.icon
                }}</mat-icon>
              </ng-template>
            </div>
            <span translate>AddButton{{ link.id }}</span>
          </div>
          <p></p>
        </div>
      }
    </div>
  </div>
</ng-template>
